import { useEffect, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import Styles from "./LiveTest.module.css";
import { useLocation, useNavigate } from "react-router-dom";
export default function MobileScore() {
  const [SideOpener, setSideOpner] = useState(false);
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  const { state } = useLocation();
  const Navigate = useNavigate();
  useEffect(() => {
    if (!state?.Result) {
    }
  }, [state]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {" "}
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} />
        <div className="main-content">
          <MobileHeaderSection Page="Live Test" OpenSideMenu={OpenSideMenu} />
          <section className={Styles.Margin4} style={{ marginTop: "30px" }}>
            <div className={Styles.Container_Ack}>
              <h4
                style={{
                  textAlign: "Center",
                  fontSize: window.innerWidth <= 480 ? "30px" : "35px",
                  margin: "15px 0",
                  fontSize: "21px",
                }}
              >
                YOU HAVE SCORED
              </h4>

              <h4
                style={{
                  textAlign: "Center",
                  fontSize: "45px",
                  color: "rgb(90, 191, 90)",
                  margin: "4px 0",
                  padding: "0",
                }}
              >
                {state?.Result}
              </h4>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "20px 0",
                }}
              >
                <button
                  style={{ background: "#2C3F8C" }}
                  onClick={() => Navigate("/dashboard")}
                  className={Styles.custom_btn}
                >
                  BACK TO DASHBOARD
                </button>
              </div>
            </div>
          </section>
          <MobileBottomMenu Page="LiveTest" />
        </div>
      </div>
    </>
  );
}
